import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import './App.css';

// Seiten importieren
import UserView from './pages/UserView';
import AdminView from './pages/AdminView';
import Datenschutz from './pages/Datenschutz';

function App() {
  const [isMenuOpen, setMenuOpen] = useState(false);

  // Admin-Panel nur in Development oder wenn explizit aktiviert
  const showAdmin = process.env.NODE_ENV === 'development' ||
                    process.env.REACT_APP_ENABLE_ADMIN === 'true';

  // Nutzer-Ansicht Button nur in Development anzeigen
  const showUserViewButton = process.env.NODE_ENV === 'development';

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    // Dispatch custom event für UserView
    window.dispatchEvent(new Event('homeNavigation'));
  };

  return (
    <Router>
      <div className="App">
        <header className="app-header">
          <div className="container">
            <NavLink to="/" className="nav-link-header" onClick={handleHomeClick}><h1>Kleinkram</h1></NavLink>
            <button className="mobile-menu-button" onClick={toggleMenu}>
              <FontAwesomeIcon icon={isMenuOpen ? faTimes : faBars} />
            </button>
            <nav className="desktop-nav">
              {showUserViewButton && (
                <NavLink to="/" className="nav-link" activeClassName="active">Nutzer-Ansicht</NavLink>
              )}
              {showAdmin && (
                <NavLink to="/admin" className="nav-link" activeClassName="active">Admin-Bereich</NavLink>
              )}
            </nav>
          </div>
        </header>

        {isMenuOpen && (
          <div className="mobile-nav">
            {showUserViewButton && (
              <NavLink to="/" className="nav-link" activeClassName="active" onClick={toggleMenu}>Nutzer-Ansicht</NavLink>
            )}
            {showAdmin && (
              <NavLink to="/admin" className="nav-link" activeClassName="active" onClick={toggleMenu}>Admin-Bereich</NavLink>
            )}
          </div>
        )}

        <main className="app-main">
          <Routes>
            <Route path="/" element={<UserView />} />
            {showAdmin && <Route path="/admin" element={<AdminView />} />}
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
        </main>

        <footer className="app-footer">
          <div className="container">
            <p>&copy; 2025 Kleinkram</p>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
